/** @format */

import './CommentItem.css';

const CommentItem = ({ content, writer, writeDate, commentId }) => {
  return (
    <div className="commentItemBox">
      <div className="commentItemTop">{writer}</div>
      <div className="commentItemMid">{content}</div>
      <div className="commentItemBottom">{writeDate.split('T')[0]}</div>
    </div>
  );
};

export default CommentItem;
